<template>
    <div>
        <div class="mask" v-if="downloadFilePop" @click="closeDownLoadPop" @touchmove.prevent @mousewheel.prevent></div>
        <div class="pop" v-if="downloadFilePop">
            <div class="no" @click="closeDownLoadPop"><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
            <div class="pop-main">
                <input type="text" placeholder="请输入邮箱" v-model="email">
                <p>{{downloadFilePopMsg}}</p>
                <div class="button" @click="sendEmail()">发送</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        downloadFilePop: {
            default:false
        },
    },
    data(){
        return{
            email: '',
            downloadFilePopMsg: ''
        }
    },
    computed:{
        userEmail(){
            return this.$store.state.myData.downloadEmail;
        },
    },
    watch: {
        userEmail(newVal, oldVal){
            if(newVal){
                this.email = newVal;
            }
        },
    },
    methods:{
        sendEmail(){
            if(!this.email){
                this.downloadFilePopMsg = '请输入正确的邮箱';
                return;
            }else{
                this.downloadFilePopMsg = '';
            }

            let reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
            if(!reg.test(this.email)){
                this.downloadFilePopMsg = '请输入正确的邮箱';
                return;
            }else{
                this.downloadFilePopMsg = '';
            }

            this.$store.commit('setDownloadEmail', this.email);
            this.$emit('sendEmail', this.email)
        },
        closeDownLoadPop(){
            this.downloadFilePopMsg = '';
            this.$emit('closeDownLoadPop')
        }
    },
    mounted(){
        if(this.userEmail){
            this.email = this.userEmail;
        }
    }
}
</script>

<style scoped lang="scss">
*{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}
.mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    z-index: 1000;
    cursor: pointer;
}
.pop{
    background: #fff;
    width: pxToVw(549);
    // height: pxToVw(272);
    height: auto;
    position: fixed;
    z-index:10001;
    left:50% ;
    transform: translate(-50%,-50%);
    top: 50%;
    padding: pxToVw(0) pxToVw(0) pxToVw(67);
    border-radius: 9px;
    .no{
        width: pxToVw(19);
        height: pxToVw(19);
        position: absolute;
        right: pxToVw(24);
        top: pxToVw(24);
        cursor: pointer;
        img{
            width: 100%;
        }
    }
    .pop-main{
        input{
        width: pxToVw(427);
        height: pxToVw(53);
        background: #FFFFFF;
        border-radius: 5px;
        border: 1px solid #DDDDDD;
        padding-left: pxToVw(24);
        font-size: pxToVw(19);
        font-weight: normal;
        color: #333;
        line-height: pxToVw(23);
        margin: pxToVw(73) pxToVw(61) pxToVw(10);
        input::-webkit-input-placeholder{
            color: #666666;

        }
    }
    p{
        color: #C50819;
        font-size: pxToVw(16);
        padding-left: pxToVw(61);
    }
    .button{
        width: pxToVw(200);
        height: pxToVw(53);
        background: #C50819;
        font-size: pxToVw(19);
        color: #FFF;
        margin: 0 auto;
        text-align: center;
        line-height: pxToVw(53);
        border-radius: 3px;
        cursor: pointer;
        margin-top:  pxToVw(15);
    } 
    }
    
}
@media screen and (max-width:767px) {
    .mask{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.5);
        z-index: 1000;
        cursor: pointer;
    }
    .pop{
        background: #fff;
        width: 82.4vw;
        // height: 41.3vw;
        height: auto;
        position: fixed;
        z-index:10001;
        left:50% ;
        transform: translate(-50%,-50%);
        top: 50%;
        padding: 0 0 9.6vw;
        border-radius: 1.1vw;
        .no{
            width: 2.8vw;
            height: 2.7vw;
            position: absolute;
            right: 3.6vw;
            top: 2.8vw;
            cursor: pointer;
            img{
                width: 100%;
            }
        }
        .pop-main{
            input{
                width: 66vw;
                height: 6.9vw;
                background: #FFFFFF;
                border-radius: 0.5vw;
                border: 1px solid #DDDDDD;
                padding-left: 2.5vw;
                font-size: 3.2vw;
                font-weight: normal;
                color: #333;
                line-height: 3.6vw;
                margin: 10.9vw 8.1vw 2vw;
                input::-webkit-input-placeholder{
                    color: #666666;
                }
            }
            p{
                color: #C50819;
                font-size: 2.8vw;
                padding-left: 8.1vw;
            }
            .button{
                width: 30.1vw;
                height: 8vw;
                background: #C50819;
                font-size: 3.2vw;
                color: #FFF;
                margin: 0 auto;
                text-align: center;
                line-height: 8vw;
                border-radius: 0.3vw;
                margin-top: 3vw;
            } 
        }
        
    }
}
</style>